export const SKELETON_ITEMS_COUNT = 6;
